if (!customElements.get('size-guide-recommender')) {
  class SizeGuideRecommender extends HTMLElement {
    connectedCallback() {
      this.heightInput = this.querySelector('[data-sgr-height]');
      this.weightInput = this.querySelector('[data-sgr-weight]');
      this.result = this.querySelector('[data-sgr-result]');
      this.ranges = this.parseRanges();

      this.querySelector('[data-sgr-submit]').addEventListener('click', this.recommend.bind(this));
      [this.heightInput, this.weightInput].forEach((input) => {
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.recommend();
          }
        });
      });
    }

    parseRanges() {
      let lines = [];
      try {
        lines = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (error) {
        return [];
      }
      return lines
        .map((line) => {
          const parts = line.split('|').map((part) => part.trim());
          if (parts.length < 3) return null;
          const height = this.parseRange(parts[1], true);
          const weight = this.parseRange(parts[2], false);
          if (!height || !weight) return null;
          return { size: parts[0], hMin: height[0], hMax: height[1], wMin: weight[0], wMax: weight[1] };
        })
        .filter(Boolean);
    }

    parseRange(text, isHeight) {
      const numbers = text.replace(/,/g, '.').match(/\d+(?:\.\d+)?/g);
      if (!numbers || numbers.length < 2) return null;
      return [this.normalize(parseFloat(numbers[0]), isHeight), this.normalize(parseFloat(numbers[1]), isHeight)];
    }

    parseValue(value, isHeight) {
      const number = parseFloat(String(value).replace(',', '.').replace(/[^\d.]/g, ''));
      if (!number || number <= 0) return null;
      return this.normalize(number, isHeight);
    }

    // Heights may come as meters (1,80) or centimeters (180) — compare in cm.
    normalize(number, isHeight) {
      return isHeight && number < 3 ? Math.round(number * 100) : number;
    }

    recommend() {
      const height = this.parseValue(this.heightInput.value, true);
      const weight = this.parseValue(this.weightInput.value, false);

      if (!height || !weight || !this.ranges.length) {
        this.showResult(this.dataset.textInvalid, null, '');
        return;
      }

      let best = null;
      let bestScore = Infinity;
      this.ranges.forEach((range) => {
        const heightGap = height < range.hMin ? range.hMin - height : Math.max(0, height - range.hMax);
        const weightGap = weight < range.wMin ? range.wMin - weight : Math.max(0, weight - range.wMax);
        const score = heightGap + weightGap;
        // On a tie the later (larger) size wins — when in doubt, size up.
        if (score <= bestScore) {
          best = range;
          bestScore = score;
        }
      });

      if (bestScore === 0) {
        this.showResult(this.dataset.textIdeal, best.size, '');
      } else {
        this.showResult(this.dataset.textClosest, best.size, this.dataset.textDoubt);
      }
    }

    showResult(prefix, size, suffix) {
      this.result.textContent = '';
      this.result.append(prefix + (size ? ' ' : ''));
      if (size) {
        const strong = document.createElement('strong');
        strong.textContent = size;
        this.result.append(strong);
      }
      if (suffix) this.result.append(' — ' + suffix);
    }
  }
  customElements.define('size-guide-recommender', SizeGuideRecommender);
}
